import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ResponseModel } from 'src/app/shared/models/ResponseModel';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class PersonDocumentsService {
  private apiUrl = environment.backUrlApi + 'PersonDocuments';
  private http = inject(HttpClient);

  uploadFile(id: string, data: any): Observable<ResponseModel<any>> {
    return this.http.post<ResponseModel<any>>(`${this.apiUrl}/upload-file?id=${id}`, data);
  }
  getDocuments(id: string): Observable<any> {
    return this.http.get<any>(`${this.apiUrl}/documents?id=${id}`);
  }
  getDocumentById(idEncrypted: string, fileId: string): Observable<any> {
    return this.http.get<any>(`${this.apiUrl}/document-by-id?idEncrypted=${idEncrypted}&id=${fileId}`);
  }
  deleteDocument(idEncrypted: string, fileId: string): Observable<any> {
    return this.http.delete<any>(`${this.apiUrl}?idEncrypted=${idEncrypted}&id=${fileId}`);
  }
    getDocumentsProcess(id: string): Observable<any> {
    return this.http.get<any>(`${this.apiUrl}/documents-process?id=${id}`);
  }
}
